import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { change } from 'redux-form';

import FormField from 'containers/FormField';
import LikertField from 'components/LikertField';

import FormProvider from 'routes/Documents/containers/FormProvider';
import InfoField from 'routes/Documents/components/InfoField';

import { fssSection, fssWrapper, padded } from './Scores.less';

import fssSections from '../FSSSections';
import { isPartialDate, nowPartialDate } from 'neuro-utils';

const FSSForm = props => {
  const { dispatch, formValues } = props;

  React.useEffect(() => {
    if (!isPartialDate(formValues.date)) dispatch(change('fss', 'date', nowPartialDate()));
  }, []);

  return (
    <FormProvider {...props}>
      <InfoField>
        <Grid fluid>
          <Row className={padded}>
            <Col xs>
              <h6 style={{ maxWidth: '85rem' }}>
                <FormattedMessage id="fss.form.infoText" />
              </h6>
            </Col>
          </Row>
          <Row>
            <Col xs>
              <h6 style={{ maxWidth: '85rem' }}>
                <FormattedMessage id="fss.form.guideText" />
              </h6>
            </Col>
          </Row>
        </Grid>
      </InfoField>
      <div className={fssWrapper}>
        {fssSections.map(fs => (
          <div key={`fatigue_${fs}`}>
            <Grid fluid className={fssSection}>
              <Row middle="xs">
                <Col xs={5}>
                  <h6>
                    <FormattedMessage id={`fss.section.${fs}`} />
                  </h6>
                </Col>
                <Col xs={7}>
                  <FormField
                    name={fs}
                    component={LikertField}
                    max={7}
                    minLabel="fss.label.disagree"
                    maxLabel="fss.label.agree"
                  />
                </Col>
              </Row>
            </Grid>
          </div>
        ))}
        <Row center="xs" style={{ marginTop: '3rem', textAlign: 'center' }}>
          <Col xs={12} sm={9}>
            <i>
              <FormattedMessage id="fss.reference" />
            </i>
          </Col>
        </Row>
      </div>
    </FormProvider>
  );
};

export default FSSForm;
